<route>
{
    "name": "dashboard",
    "meta": {
        "title": "Dashboard",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "secretar", "secretar_secundar", "instructor"],
        "fail": "/403"
    }
}
</route>
<template>
  <main-layout>
      <v-container v-if="getMe">
          <h1 class="pt-3">Salut {{ getMe.name }}!</h1>
      </v-container>
      <v-container grid-list-xl>
          <v-layout wrap>
              <v-row>
                  <v-col>

                  </v-col>
              </v-row>
          </v-layout>
      </v-container>
  </main-layout>
</template>

<script>
import MainLayout from "Layouts/Main.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import ACL from "Mixins/acl";

export default {
    mixins: [ACL],
    components: {
        MainLayout
    },
    computed: {
        ...mapGetters({
            getMe: "getMe"
        })
    },
    async mounted () {
        this.loading = false
    }
};
</script>
